import React from 'react'
import { BUS_RESULT, BusResultCard } from '../BusResults'
import SeatBookingPanel from './SeatBookingPanel'

// Standalone version of the Photos & Amenities view — kept for direct
// linking/preview, mirroring busSeatSelection.jsx / busBoardingPage.jsx.
const BusPhotosPage = () => {
    return (
        <>
            <section className='commonTopPadding commonBottomPadding'>
                <div className='container'>
                    <div className='row g-4'>
                        <div className='col-md-12'>
                            <BusResultCard item={BUS_RESULT} />
                            <SeatBookingPanel initialTab='photosAmenities' />
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default BusPhotosPage
